import type { ServiceCode } from '../../common/enums/serviceCode';
import type { ValidationErrors } from './validation';
import { ServiceType } from '../../common/enums/serviceType';
import {
    servicesWithPatienUsesMedicationForProcedure,
    servicesWithPatienUsesMedicationForRequest,
} from '../../common/validation/medication';

export function patientUsesMedicationValidation(
    type: 'request' | 'procedure',
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    patientUsesMedication: boolean | null,
    errors: ValidationErrors
) {
    const servicesWithPatienUsesMedication =
        type === 'request' ? servicesWithPatienUsesMedicationForRequest : servicesWithPatienUsesMedicationForProcedure;

    if (
        servicesWithPatienUsesMedication.includes(serviceCode) &&
        serviceType !== ServiceType.contact &&
        patientUsesMedication === null
    ) {
        return errors.set('patientUsesMedication', 'any_selected');
    }

    return errors;
}
